import { z } from 'zod';

import type { SnakeToCamelCase } from '../../../utils/types';
import { PlanTypesEnum, SocialStarterPlanTypesEnum, EventsV1PlanTypesEnum } from '../../../value-objects/plan-group';

export const TierSchema = z.object({
  current: z.boolean().nullable(),
  price: z.number(),
  pricing_qualifier: z.number().nullable(),
  pricing_qualifier_usage_type_id: z.number().nullable(),
  tier: z.number(),
  tier_max: z.number(),
  tier_min: z.number(),
});

export const PlanTypesEnumSchema = z.nativeEnum(PlanTypesEnum);

export const SocialStarterPlanTypesEnumSchema = z.nativeEnum(SocialStarterPlanTypesEnum);

export const EventsV1PlanTypesEnumSchema = z.nativeEnum(EventsV1PlanTypesEnum);

export const PlanSchema = z.object({
  id: z.number(),
  planName: z.string(),
  recommended_plan: z.boolean(),
  tiers: z.array(TierSchema),
  type: PlanTypesEnumSchema.or(SocialStarterPlanTypesEnumSchema).or(EventsV1PlanTypesEnumSchema),
  displayOnPay: z.boolean().optional(),
});

export const FeatureCategoriesSchema = z.object({
  name: z.string(),
  offer_features: z.array(
    z.object({
      available_email: z.boolean(),
      available_email_plus: z.boolean(),
      email_availability_descriptions: z.string(),
      email_plus_availability_descriptions: z.string(),
      name: z.string(),
      tooltip: z.string(),
    })
  ),
});

export const PlanGroupResponseSchema = z.object({
  currentPlanId: z.number().nullable(),
  experience: z.string().nullable(),
  featureCategories: z.array(FeatureCategoriesSchema).nullable(),
  paymentPlanId: z.number(),
  planGroupType: z.string(),
  planIdsBySeqNo: z.record(z.number()),
  plans: z.array(PlanSchema),
  recommendedPlanId: z.number(),
});

// TypeScript Interfaces
export type ApiTier = z.infer<typeof TierSchema>;

export type ApiPlan = z.infer<typeof PlanSchema>;

export type ApiFeatureCategories = z.infer<typeof FeatureCategoriesSchema>;

export type ApiPlanGroupResponse = z.infer<typeof PlanGroupResponseSchema>;

export type Tier = SnakeToCamelCase<ApiTier>;

export type Plan = SnakeToCamelCase<ApiPlan>;

export type FeatureCategories = SnakeToCamelCase<ApiFeatureCategories>;

export type ParsedPlanGroupResponse = SnakeToCamelCase<ApiPlanGroupResponse>;
